export default __webpack_public_path__ + "static/media/left_header.2d208bbb.svg";